import { render, staticRenderFns } from "./charmActionDetail.vue?vue&type=template&id=6d1a65d2"
import script from "./charmActionDetail.vue?vue&type=script&lang=js"
export * from "./charmActionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1a65d2')) {
      api.createRecord('6d1a65d2', component.options)
    } else {
      api.reload('6d1a65d2', component.options)
    }
    module.hot.accept("./charmActionDetail.vue?vue&type=template&id=6d1a65d2", function () {
      api.rerender('6d1a65d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/action/charmActionDetail.vue"
export default component.exports